import { Link } from "@/lib/react-router-dom-shim";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { LazyCartSheet } from "./LazyCartSheet";
import { UserMenu } from "./UserMenu";
import LanguageSwitcher from "./LanguageSwitcher";
import logo from "@/assets/logo.png";

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const navigation = [
    { name: t('nav.hotels'), href: "/hoteles" },
    { name: t('nav.resorts'), href: "/resorts" },
    // Temporarily hidden for launch - only hotels available
    // { name: t('nav.cars'), href: "/coches" },
    // { name: t('nav.activities'), href: "/actividades" },
  ];

  return (
    <>
      {/* Skip to content link for accessibility */}
      <a 
        href="#main-content" 
        className="skip-to-content"
      >
        {t('accessibility.skipToContent', 'Skip to main content')}
      </a>
      <nav className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60" aria-label="Navegación principal">
        <div className="container mx-auto px-4">
          <div className="flex h-16 items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center" aria-label="Ir a la página principal">
            <img 
              src={logo} 
              alt="Fora da Rota" 
              className="h-6 w-auto sm:h-9"
              width={244}
              height={56}
              loading="eager"
              fetchPriority="high"
              decoding="async"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden items-center space-x-8 md:flex">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="text-sm font-medium text-foreground transition-colors hover:text-primary"
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* Actions */}
          <div className="flex items-center space-x-2 sm:space-x-4">
            <LanguageSwitcher />
            <LazyCartSheet />
            <div className="hidden sm:flex">
              <UserMenu />
            </div>

            {/* Mobile menu */}
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild className="md:hidden">
                <Button variant="ghost" size="icon" aria-label={isOpen ? t('nav.closeMenu', 'Cerrar menú') : t('nav.openMenu', 'Abrir menú')}>
                  {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-64">
                <div className="mt-8 flex flex-col space-y-4">
                  {navigation.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      onClick={() => setIsOpen(false)}
                      className="text-lg font-medium text-foreground transition-colors hover:text-primary"
                    >
                      {item.name}
                    </Link>
                  ))}
                  <div className="border-t pt-4 space-y-4">
                    <LanguageSwitcher />
                    <div onClick={() => setIsOpen(false)}>
                      <UserMenu />
                    </div>
                  </div>
                </div>
              </SheetContent>
            </Sheet>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
